import { makeObservable, observable, action, reaction } from 'mobx';
import axios, { storeGet } from "../utils/axios";
import historyVars from "../utils/historyVars";
import errors from "../reducers/errors";

class meStore {
  me={ fetching: false,inited: false, data:{}};
  par=null;

  constructor(par) {
    this.par=par;
    makeObservable(this, {
      me: observable,
    });
  }
  setNewPasswordByRecovery(values) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/user/setpassword`, values).then((item) => {
        if (item.data.errors) {
          reject(item.data.errors);
        } else {
          this.fetchMe();
          resolve(item.data.answer);
        }
      });
    });
  }
  recoverPassword(values) {
    return new Promise((resolve, reject) => {
      axios.post(`/api/user/recovery`, values).then((item) => {
        if (item.data.errors) {
          reject(item.data.errors);
        } else {
          resolve(item.data.answer);
        }
      });
    });

  }
  confirmEmail(values) {
    return new Promise((resolve, reject)=>{
      axios.post(`/api/user/confirm`, values).then((item) => {
        if (item.data.errors) {
          reject(item.data.errors);
        } else {
          this.fetchMe();
          resolve(item.data.answer);
        }
      });
    });
  }
  register(values) {
    return new Promise((resolve,reject)=> {
      axios.post(`/api/user/register`, values).then((item) => {
        if (item.data.errors) {
          reject(item.data.errors);
        } else {
          resolve(item.data.answer);
        }
      });
    });
  }
  auth(values) {
    return new Promise((resolve,reject)=> {
      axios.post(`/api/user/auth`, values).then((item) => {
        if (item.data.errors) {
          reject(item.data.errors);
        } else {
          this.fetchMe();
          resolve(item.data.answer);
        }
      });
    });
  }
  logOut() {
    axios.get('/api/user/logout').then((item) => {
      if (item.data.answer === true) {
        this.fetchMe();
      }
    });
  }
  fetchMe() {
    storeGet(`/api/user/me`, this.me);
  }

}


export default meStore;
